.shell {
  display: grid;
  grid-template-columns: 244px 1fr;
  min-height: 100vh;
  background: var(--bg);
}

.sidebarCol {
  background: var(--ink);
  border-right: 1px solid var(--ink-2);
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.mainCol {
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: 0 32px 48px;
  gap: 0;
}
